import { wrapper, createApiClient, ApiError, Result } from "../base";
import ExportDO = App.Data.ExportDO;
import ExportListDO = App.Data.ExportListDO;
import { LaravelPaginatedCollection } from "@/types/collections";

const baseClient = createApiClient();

export default class {
	index(params: {
		page: number;
		per_page: number;
		sort?: string;
	}): Promise<Result<LaravelPaginatedCollection<ExportListDO>, ApiError>> {
		return wrapper(baseClient.get(`exports`, { params }));
	}

	show(uuid: string): Promise<Result<ExportDO, ApiError>> {
		return wrapper<ExportDO>(baseClient.get(`exports/${uuid}`));
	}

	download(uuid: string): Promise<Result<Blob, ApiError>> {
		return wrapper(
			baseClient.get(`exports/${uuid}/download`, { responseType: "blob" })
		);
	}
}
